var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 14,
    viewBox: "0 0 51 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.3125 3.14542V0.236328H11.8709V3.14542H7.87094V13.535H4.3125V3.14542H0.3125ZM15.7371 13.535H11.841L16.2306 0.236328H21.1657L25.5553 13.535H21.6592L18.7501 3.89867H18.6462L15.7371 13.535ZM15.0098 8.28828H22.3345V10.9896H15.0098V8.28828ZM27.5676 13.535V0.236328H31.178V10.6259H36.5546V13.535H27.5676ZM38.7454 13.535V0.236328H42.3558V5.61295H42.5376L46.5376 0.236328H50.7454L46.2519 6.15841L50.8493 13.535H46.5376L43.5506 8.54802L42.3558 10.1065V13.535H38.7454Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalk);
export default __webpack_public_path__ + "static/media/talk.2f820fbeacce7fc5122355be91e1ee09.svg";
export { ForwardRef as ReactComponent };